import { Formik } from 'formik';
import pluralize from 'pluralize';
import React, { useRef } from 'react';
import * as Yup from 'yup';
import { Field, Form } from '~/components';
import BulkActionModal from '~/components/bulk-action/BulkActionModal';
import FixedDropdown from '~/components/FixedDropdown';
import { useApi, useWorkspace } from '~/contexts';
import TaskDetails from './TaskDetails';

export default function BulkChangeType({ projectId, ids, onClose, onComplete }) {
  const { workspace } = useWorkspace();
  const api = useApi();
  const formRef = useRef();

  return (
    <BulkActionModal
      title="Bulk Change Task Type"
      onClose={onClose}
      onComplete={onComplete}
      onConfirm={() => formRef.current?.submitForm()}
      renderRow={TaskDetails}>
      <Formik
        innerRef={formRef}
        initialValues={{ taskType: null }}
        onSubmit={async (values) => {
          return api.www
            .workspaces(workspace.id)
            .projects(projectId)
            .tasks()
            .bulkSetTaskType(ids, { projectTaskTypeId: values.taskType.id })
            .then((r) => r.data);
        }}
        validateOnBlur={false}
        validateOnChange={false}
        validationSchema={Yup.object().shape({
          taskType: Yup.object().label('Task Type').nullable().required(),
        })}>
        {() => (
          <Form>
            <p>
              Change the task type of {ids.length} {pluralize('task', ids.length)} to:
            </p>

            <Form.Control>
              <Field.ProjectTaskTypeSelect
                name="taskType"
                placeholder="Task Type"
                clearable={false}
                component={FixedDropdown}
              />
            </Form.Control>
          </Form>
        )}
      </Formik>
    </BulkActionModal>
  );
}
